import { render } from "./NavBarcommunity.vue?vue&type=template&id=1afb169a&scoped=true"
import script from "./NavBarcommunity.vue?vue&type=script&lang=js"
export * from "./NavBarcommunity.vue?vue&type=script&lang=js"

import "./NavBarcommunity.vue?vue&type=style&index=0&id=1afb169a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1afb169a"]])

export default __exports__